import React, { useEffect, useRef } from 'react';

import Link from '@atlaskit/link';
import SectionMessage, { SectionMessageAction } from '@atlaskit/section-message';
import { FormattedMessage, useIntl } from '@atlassian/jira-intl';
import getMeta from '@atlassian/jira-get-meta';

import {
	fireScreenAnalytics,
	fireUIAnalytics,
	useAnalyticsEvents,
} from '@atlassian/jira-product-analytics-bridge';
import { useBanner } from '../../use-banner.tsx';
import { BANNER_LINK_ACTION_SUBJECT_ID } from '../constants.tsx';
import messages from './messages.tsx';

const BANNER_ID = 'activate-home-dashboards-banner';

export const ActivateHomeDashboardsBanner = () => {
	const { formatMessage } = useIntl();
	const organizationId = getMeta('ajs-org-id');
	const optInUrl = `https://admin.atlassian.com/o/${organizationId}/townsquare`;
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const hasFiredScreenEvent = useRef<boolean>(false);

	const homeCommunityPost =
		'https://community.atlassian.com/forums/Atlassian-Home-articles/Home-Dashboards-available-in-open-beta/ba-p/3009544';

	const { isDismissed, handleDismiss } = useBanner(BANNER_ID);
	const shouldHideBanner = isDismissed || !organizationId;

	useEffect(() => {
		if (!hasFiredScreenEvent.current && !shouldHideBanner) {
			fireScreenAnalytics(createAnalyticsEvent({}), {
				bannerType: 'optInHome',
			});
			hasFiredScreenEvent.current = true;
		}
	}, [createAnalyticsEvent, shouldHideBanner]);

	if (shouldHideBanner) {
		return null;
	}

	return (
		<SectionMessage
			actions={[
				<SectionMessageAction key="dismiss-button" onClick={handleDismiss}>
					{formatMessage(messages.dismissButtonText)}
				</SectionMessageAction>,
			]}
		>
			<FormattedMessage
				{...messages.betaBannerText}
				values={{
					a: (chunks) => (
						<Link
							href={homeCommunityPost}
							onClick={(_, analyticsEvent) =>
								fireUIAnalytics(analyticsEvent, BANNER_LINK_ACTION_SUBJECT_ID, {
									urlType: 'opt-in-home-dashboards-community-post',
								})
							}
						>
							{chunks}
						</Link>
					),
					b: (chunks) => (
						<Link
							href={optInUrl}
							onClick={(_, analyticsEvent) =>
								fireUIAnalytics(analyticsEvent, BANNER_LINK_ACTION_SUBJECT_ID, {
									urlType: 'opt-in-home-dashboards',
								})
							}
						>
							{chunks}
						</Link>
					),
				}}
			/>
		</SectionMessage>
	);
};
